import { render, staticRenderFns } from "./inventoryCheck.vue?vue&type=template&id=1896a7e0&scoped=true&"
import script from "./inventoryCheck.vue?vue&type=script&lang=js&"
export * from "./inventoryCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1896a7e0",
  null
  
)

export default component.exports